<template>
    <div>
        <div class="p-grid">
            <app-menu-bar title="Form Dokumen Pengadaan" back_url="/dokumen_pengadaan" />
            <Card class="p-fluid">
                <template #content>
                    <Form :modelValue="form" @update:modelValue="form = $event" :errors="errors"></Form>

                </template>
                <template #footer>
                    <div class="field grid">
                        <div class="col-offset-2">
                            <Button icon="pi pi-send" label="Simpan" class="p-button p-button-primary ml-2"
                                @click="submitForm()" />
                        </div>
                    </div>
                </template>
            </Card>
        </div>
    </div>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import DataTable from "primevue/datatable";
import InputText from "primevue/inputtext";
import Password from "primevue/password";
import Menubar from "primevue/menubar";
import AppMenuBar from "../../Components/AppMenuBar.vue";
import Calendar from 'primevue/calendar';
import { FilterMatchMode } from "primevue/api";
import { useForm } from "@inertiajs/inertia-vue3"
import Column from "primevue/column";
import Button from "primevue/button";
import Divider from "primevue/divider";
import Card from "primevue/card";
import DeleteDialog from "../../Components/DeleteDialog";
import { Inertia } from '@inertiajs/inertia'
import MultiSelect from 'primevue/multiselect';
import DropdownWilayah from "../../Components/DropdownWilayah.vue";
import Form from "./partials/Form.vue";
// import PermissionTreeTable from '../../Components/PermissionTreeTable';

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        AppLayout,
        Menubar,
        AppMenuBar,
        DataTable,
        Column,
        Button,
        DeleteDialog,
        InputText,
        Password,
        Card,
        Divider,
        MultiSelect,
        Calendar,
        DropdownWilayah,
        Form
    },
    props: {
        errors: Array,
        additional_data: Array,
        form: Array,
    },
    data: function () {
    },
    methods: {
        submitForm() {

            Inertia.put(`/dokumen_pengadaan/${this.form.id}`, this.form);

        }
    }
}
</script>
